import { useEffect } from "react";
export function useBodyScrollLock(lock) {
    useEffect(() => {
        document.body.classList.toggle("overflow-hidden", lock);
        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [lock]);
}
